/**
 * ChartDetailsToggle — a gold-outline row that opens and closes a block under it (the chart tables).
 * Collapsed at first; the state is not saved. The block stays in the DOM (`hidden`) so `aria-controls`
 * always points at something.
 */
import { useId, useState, type ReactNode } from 'react';
import styles from './ChartDetailsToggle.module.css';

export interface ChartDetailsToggleProps {
  label: string;
  children: ReactNode;
}

export function ChartDetailsToggle({ label, children }: ChartDetailsToggleProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const regionId = useId();
  return (
    <>
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={open}
        aria-controls={regionId}
        onClick={() => setOpen((v) => !v)}
        data-testid="chart-details-toggle"
      >
        <span className={styles.label}>{label}</span>
        <svg className={styles.chevron} viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
          <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div id={regionId} hidden={!open} data-testid="chart-details">
        {children}
      </div>
    </>
  );
}
